import React from 'react';
import { useTranslation } from 'react-i18next';
import { DashboardLayout, Card } from '../components';
import { Breadcrumb } from '../components/Breadcrumb';
import { CompanyThemeEditor } from '../components/company-theme/CompanyThemeEditor';

/** Inställningar → Tema: the company's logo and contract colours. */
export function CompanyThemeSettings() {
  const { t } = useTranslation();

  return (
    <DashboardLayout>
      <div className="page-header mb-4">
        <div className="page-header-left d-flex align-items-center">
          <div className="page-header-title">
            <h5 className="fw-bold mb-0">{t('settings.theme.title')}</h5>
          </div>
          <Breadcrumb items={[
            { label: t('nav.home'), path: '/home' },
            { label: t('settings.theme.title') }
          ]} />
        </div>
        <div className="page-header-right ms-auto d-none d-sm-block">
          <p className="fw-bold text-muted mb-0">{t('settings.theme.description')}</p>
        </div>
      </div>
      <Card>
        <div className="card-body">
          <CompanyThemeEditor api="company" />
        </div>
      </Card>
    </DashboardLayout>
  );
}

export default CompanyThemeSettings;
